import React, { createContext, useEffect, useState, PropsWithChildren } from 'react';
import {
  BeaconControlData,
  PlayerEvents,
  PlayerActions,
  PlayerControlData,
  PlayerEventData,
} from '../../../index';
import usePlayerEventData from '../../../hooks/usePlayerEventData/usePlayerEventData'
export interface PresentationPlayerType {
  playerEventData?: PlayerEventData,
  currentPlayerState?: BeaconControlData,
  setCurrentPlayerState: React.Dispatch<React.SetStateAction<BeaconControlData | undefined>>
}

export const PresentationPlayerContext = createContext<PresentationPlayerType>(null!)
PresentationPlayerContext.displayName = 'PresentationPlayerContext'

interface InitialValues { }

const PresentationPlayerProvider: React.FC<PropsWithChildren<InitialValues>> = (props) => {
  const playerEventData = usePlayerEventData()
  const [currentPlayerState, setCurrentPlayerState] = useState<BeaconControlData>()

  /**
   * playerEventData useEffect handler which watches for player status updates and
   * stores them as jumpToAnim PlayerControlData messages in currentPlayerState.
   * This can then be used in the virtual environment to support init of attendees
   * joining mid presentation.
   */
  const handlePlayerEvent = () => {
    if (playerEventData?.event === PlayerEvents.statusEvent) {
      const newParam = {
        step: playerEventData.param.step,
        slide: playerEventData.param.slide,
      }
      const updatedPlayerState = new PlayerControlData(
        PlayerActions.jumpToAnim,
        newParam,
      )
      setCurrentPlayerState(updatedPlayerState)
    }
  }
  useEffect(handlePlayerEvent, [playerEventData])

  const contextValue:PresentationPlayerType = {
    playerEventData,
    currentPlayerState,
    setCurrentPlayerState,
  }

  return (
    <PresentationPlayerContext.Provider value={contextValue}>
      {props.children}
    </PresentationPlayerContext.Provider>
  )
}

PresentationPlayerProvider.displayName = 'PresentationPlayerProvider'
export default PresentationPlayerProvider
